import { cardRef, defineDeck } from '../authoring/index.js';
function refs(ids) {
    return ids.map(cardRef);
}
export const starterDecks = Object.freeze([
    defineDeck({
        id: 'overload',
        name: 'Перегрев',
        description: 'Быстрые машины атакуют в раунд раскрытия, греются и требуют охлаждения.',
        strength: 'Раннее давление и мощные атаки по темпу.',
        weakness: 'Без охлаждения ключевые карты расплавляются.',
        cards: refs([
            'impulse_fighter',
            'overclocked_scout',
            'cooling_drone',
            'heat_sink',
            'arc_conductor',
            'siege_resonator',
            'titan_prototype',
            'liquid_cooling',
            'emergency_vent',
            'power_reroute',
            'defensive_circuit',
            'red_zone',
        ]),
        availability: 'available',
    }),
    defineDeck({
        id: 'spare_parts_swarm',
        name: 'Рой запчастей',
        description: 'Погибшие машины оставляют материал, который собирается в новых роботов и полезный Хлам.',
        strength: 'Заполняет поле и извлекает ценность из собственных токенов.',
        weakness: 'Зависит от свободных ячеек и правильной последовательности Сборок.',
        cards: refs([
            'assembly_robot',
            'scrap_transporter',
            'self_copying_drone',
            'junk_dealer',
            'riveter',
            'trash_critter',
            'everything_machine',
            'spare_part',
            'scatter_bolts',
            'junk_barricade',
            'welding_pulse',
            'recycling',
        ]),
        availability: 'available',
    }),
    defineDeck({
        id: 'slime',
        name: 'Колония слизней',
        description: 'Хрупкие слизни оставляют Склизь, заполняют локации и поглощают союзные тела ради постоянных характеристик.',
        strength: 'Высокий урон, накопление силы ячеек и гибкое Поглощение.',
        weakness: 'Большинство слизней легко погибает и требует свободных ячеек или подготовленных доноров.',
        cards: refs([
            'acidic_slime',
            'dividing_slime',
            'leaking_clot',
            'colony_predator',
            'slippery_slime',
            'budding_belly',
            'overgulper',
            'colony_devourer',
            'pull_into_clot',
            'liquefaction',
            'slimefall',
            'crush_and_strain',
        ]),
        availability: 'available',
    }),
    defineDeck({
        id: 'living_interior',
        name: 'Живой интерьер',
        description: 'Ожившая мебель обставляет целую комнату, переживает размены и превращает разрушенные предметы в новые карты.',
        strength: 'Позиционные бонусы полной комнаты, защитные размены и стабильный добор.',
        weakness: 'Требует занять три ячейки одной локации и уязвима к рассеиванию поля.',
        cards: refs([
            'four_legged_chair',
            'dazzling_lamp',
            'falling_door',
            'crooked_mirror',
            'grandmas_blanket',
            'drop_the_piano',
            'dining_table',
            'soft_sofa',
            'reader_armchair',
            'spring_cleaning',
            'junk_chest',
            'assault_stool',
        ]),
        availability: 'available',
    }),
]);
//# sourceMappingURL=decks.js.map